import {Inject, Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {AccountInfo} from '@azure/msal-common';
import {
    MsalService,
    MSAL_GUARD_CONFIG,
    MsalGuardConfiguration
} from '@azure/msal-angular';
import {UserService} from './user.service';
import {InteractionType, PopupRequest, RedirectRequest} from '@azure/msal-browser';
import {environment} from '../../environments/environment';

interface Account extends AccountInfo {
    idTokenClaims?: {
        preferred_username?: string,
        roles?: string[],
        groups?: string[],
        _claim_names?: {
            groups: string | string[]
        },
        _claim_sources?: {
            src1: {
                endpoint: string | string[]
            }
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class GroupGuardService implements CanActivate {

    constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
                private authService: MsalService,
                private userService: UserService) {
    }

    canActivate(): boolean {
        let account: Account = this.authService.instance.getAllAccounts()[0];
        if (!account) {
            return false;
        }

        this.userService.setAzureUserName(account.idTokenClaims?.preferred_username!);
        if (account.idTokenClaims?.groups?.includes(environment.entraGroup)) {
            return true;
        }

        window.alert('You do not have access for this.');
        return false;
    }
}
